export default __webpack_public_path__ + "static/media/banner_2.2.64feda39.png";